<template>
  <DBox
    :id="'dtplugins-dbox-sales'"
    :addButton="false"
    :searchButton="true"
    :searchFlag="searchFlag"
    :addLink="false"
    :rightMenu="
      rightMenu.map((e) => ({
        ...e,
        text: $t(e.text),
      }))
    "
    :badgeButtons="
      filterExists
        ? [
            {
              text: $t('reset_filters'),
              value: 'reset_filters',
              icon: 'delete-white',
            },
          ]
        : []
    "
    @addClick="onAddClick"
    @menuClick="onRightMenuClick"
    @badgeClick="onBadgeClick"
    @searchClick="onSearchClick"
    :class="{
      no_items: items.length == 0,
    }"
  >
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <Dropdown
          :options="accountsTV"
          :selected="accountsTV.find((e) => e.value == dboxMetaData.account_id)"
          :placeholder="'Account'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('account_id', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
        <Dropdown
          :options="periodsTV"
          :selected="periodsTV.find((e) => e.value == dboxMetaData.period)"
          :placeholder="'Period'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('period', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
        <Dropdown
          :options="countriesTV"
          :selected="
            countriesTV.find((e) => e.value == dboxMetaData.country_id)
          "
          :placeholder="'Country'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('country_id', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
        <Dropdown
          v-if="hasTransaction"
          :options="transaction_typesTV"
          :selected="
            transaction_typesTV.find(
              (e) => e.value == dboxMetaData.transaction_type
            )
          "
          :placeholder="'Transaction Type'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('transaction_type', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
        <Dropdown
          v-if="!hasTransaction"
          :options="usageTypeTV"
          :selected="usageTypeTV.find((e) => e.value == usage_type)"
          :placeholder="'Select Usage Type'"
          deselect
          borderbottom
          v-on:selectedChange="(e) => onFilterSelected('usage_type', e)"
          :style="{
            width: '178px',
          }"
        ></Dropdown>
      </div>
      <button @click="onApplyFilter" class="dt-button dt-button v5 s8 m8">
        Apply Filter
      </button>
    </div>
    <div
      class="ut-fh"
      :style="{
        height: this.searchFlag ? `calc(100% - 52px)` : undefined,
      }"
    >
      <NTable
        id="dtplugins-dbox_cost-cost_list dbox1"
        :config="tableConfig"
        :headers="headers"
        :items="items"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('date')">
              <span class="ut-flex txtov">
                {{ item["account_pos_date"] }}
              </span>
            </td>
            <td v-bind="tdcon('account')">
              <span class="ut-flex txtov">
                {{ item["account_name"] }}
              </span>
            </td>
            <td v-bind="tdcon('reference')" style="padding: 4px 0px">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-start;
                "
              >
                <span class="txtov" @click="(e) => onStatementClick(item)"
                  >{{ item["reference_table"] }},
                  {{ item["reference_id"] }}</span
                >
                <span
                  class="ut-link txtov ut-link ut-text-accent5"
                  @click="(e) => onInvoiceClick(item)"
                  >{{ item["invoice_ref"] }}</span
                >
              </div>
            </td>
            <td v-bind="tdcon('country')">
              <span v-if="hasTransaction" class="txtov">
                {{ getCountryISO(item["country_id"]) }}
              </span>
              <span v-else class="txtov">
                {{ item["country_fullname"] }}
              </span>
            </td>

            <td v-bind="tdcon('qty')">
              <span class="txtov">
                {{ item["qty"] }}
              </span>
            </td>
            <td v-bind="tdcon('type')">
              <span class="txtov">
                {{ item["transaction_type_txt"] }}
              </span>
            </td>
            <td v-bind="tdcon('ppdppu')">
              <div class="ut-fc">
                <span :title="$dft.curr(item['ppd'])" class="txtov">
                  {{ $dft.currFixed(+item["ppd"], 17) }}
                  <!-- {{+item["ppd"]}} -->
                </span>
                <span :title="$dft.curr(item['ppu'])" class="txtov">
                  {{ $dft.currFixed(+item["ppu"], 17) }}
                  <!-- {{+item["ppu"]}} -->
                </span>
              </div>
            </td>
            <!-- <td v-bind="tdcon('ppu')">
              <span class="txtov">
                {{ item["ppu"] }}
              </span>
            </td> -->
            <td v-bind="tdcon('currency')">
              <span class="txtov">
                {{ item["currency_iso"] }}
              </span>
            </td>
            <td v-bind="tdcon('turnover_fix_sys_curr')">
              <span class="txtov">
                {{ $dft.currFixed(+item["turnover_fix_sys_curr"], 17) }}
                <!-- {{ item["turnover_fix_sys_curr"] }} -->
              </span>
            </td>
          </tr>
        </template>
      </NTable>
      <div
        v-if="showTotal"
        style="z-index: 1; position: absolute; margin: 14px"
      >
        {{ $t("total") }} : {{ totalQty }}
      </div>
    </div>
  </DBox>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import NTable from "@/plugins/datatable/datatable";

import { createNTableConfig, createTableHeader } from "../../plugins/datatable";

import InputField from "@plugins/text-field/input-field";

import { capitalizeFirst, toSnakeCase } from "../../utility";
import { createTV } from "../../models/text-value.model";

import {
  closeModalRoute,
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../modal/modal.mixin";

import { confirmDelete } from "../confirmation/confirmation-common";
import { useDBoxStore } from "../dboxstore/dboxstore.mixin";
import { invoiceListLDTRoutes } from "../../modules/accounting/router/routes";
import { routeWithFrom } from "../../utility/route";
import { DBoxSalesService } from "./dbox-sales.service";
import FileDownload from "js-file-download";

/** @type {PromiseLike<string>} */
export default {
  components: {
    Modal,
    NTable,
    InputField,
  },
  props: {
    hasTransaction: {
      default: true,
      type: Boolean,
    },
    showTotal: {
      default: false,
      type: Boolean,
    },
    rowHeight: {
      default: 28,
      type: Number,
    },
    rightMenu: {
      default: () => {
        return [
          {
            text: "export",
            value: "export",
          },
        ];
      },
      type: Array,
    },
  },
  data() {
    return {
      searchFlag: false,

      selectedCostGroup: null,

      tableHeight: `236px`,

      selectedCostItem: null,
      usage_type: "",
      totalQty: 0,
    };
  },
  mixins: [useDBoxStore()],
  computed: {
    tableConfig: () => createNTableConfig({
        headerStyle: 3,
        rowHeight: 48,
        headerHeight: 32,
        fullHeight: true,
      }),
    headers: function () {
      return [
        //f: 0.095
        //f: 0.155
        createTableHeader("date", { mw: 90 }),
        createTableHeader("account", { f: 0.198 }),
        createTableHeader("reference", { f: 0.174 }),
        createTableHeader("country", { f: 0.11 }),
        createTableHeader("qty", { f: 0.058, ta: "right" }),
        createTableHeader("type", { f: 0.115 }),
        createTableHeader("ppdppu", {
          mw: 150,
          minw: 150,
          text: "ppdppu",
          ta: "right",
        }),
        createTableHeader("currency", { f: 0.083 }),
        createTableHeader("turnover_fix_sys_curr", {
          text: `${this.$t("turnover")} EUR`,
          mw: 150,
          minw: 150,
          ta: "right",
        }),
      ];
    },
    filterExists() {
      return (
        this.dboxMetaData.transaction_type ||
        this.dboxMetaData.account_id ||
        this.dboxMetaData.country_id ||
        this.dboxMetaData.period
      );
    },
    costModalKey() {
      return `costForm`;
    },
    costModalRouteKey() {
      return toSnakeCase(this.costModalKey);
    },
    otherIncomeModalKey() {
      return `otherIncomeForm`;
    },
    otherIncomeModalRouteKey() {
      return toSnakeCase(this.otherIncomeModalKey);
    },
    items() {
      return this.dboxPluginStore?.dboxData?.sales || [];
    },
    dboxData() {
      return this.dboxPluginStore?.dboxData || [];
    },
    itemName() {
      return this.storeConfig.itemsKey == "costs" ? "Cost" : "Other Income";
    },
    isCost() {
      return this.storeConfig.itemsKey == "costs";
    },
    isOtherIncome() {
      return this.storeConfig.itemsKey != "costs";
    },
    accountsTV() {
      return createTV(this.dboxData.accounts, "account_name", "account_id");
    },
    usageTypeTV() {
      return [
        { text: "DL", value: "DL" },
        { text: "STR", value: "STR" },
      ];
    },
    periodsTV() {
      return createTV(
        this.dboxData.periods.map((e) => ({
          ...e,
          text: `${capitalizeFirst(e.month)} ${e.year}`,
        })),
        "text",
        "month_val"
      );
    },
    countriesTV() {
      return createTV(
        this.dboxData.countries,
        "country_fullname",
        "country_id"
      );
    },
    transaction_typesTV() {
      return (
        createTV(
          this.dboxData.transaction_types.map((e) => ({
            ...e,
            textkey: this.$t(e.textkey),
          })),
          "textkey",
          "value"
        ) || []
      );
    },
    selectedCostSplitId() {
      return this.$route.query.cost_split_id;
    },
  },
  methods: {
    getCountryISO(id) {
      return (
        this.dboxData?.countries?.find((e) => e.country_id == id)
          ?.country_fullname || ""
      );
    },

    getFilterText: function (tvArrayKey, valueKey) {
      return this[tvArrayKey].find(
        (e) => e.value == this.dboxMetaData[valueKey]
      )
        ? this[tvArrayKey].find((e) => e.value == this.dboxMetaData[valueKey])
            .name
        : "";
    },

    onRightMenuClick: async function (menu) {
      if (menu == "export") {
        console.log({ menu: menu });

        const params = {
          period_txt: this.getFilterText("periodsTV", "period"),
          country: this.getFilterText("countriesTV", "country_id"),
          account: this.getFilterText("accountsTV", "account_id"),
          transaction_type_txt: this.getFilterText(
            "transaction_typesTV",
            "transaction_type"
          ),
        };

        console.log(this.dboxMetaData, "::::::::::::::::", params);

        const fileURL = DBoxSalesService.exportSales({
          product_id: this.storeConfig.primaryKeyValue,
          ...this.dboxMetaData,
          ...params,
        });

        console.log({ fileURL: fileURL });
        location.href = fileURL;
        // console.log({"fileURL": fileURL});

        // FileDownload(fileURL.data, "product_sales.xlsx");
      }
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit("showSearchFlag", this.searchFlag);
    },
    onSearchInputKeyup: function (event) {
      const value = event.target.value;
      this.dboxPluginStore.updateDBoxStore(
        (e) => e,
        (metadata) => {
          return {
            ...metadata,
            str: value,
          };
        }
      );
    },
    onAddClick() {},
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        console.log({ badge: badge });
        this.dboxPluginStore.updateDBoxStoreMetaData((metadata) => {
          return this.resetFilter();
        });
        this.onApplyFilter();
        this.searchFlag = false;
      }
    },
    onFilterSelected(name, value) {
      console.log({ name: name, value });
      if (name == "transaction_type") {
        const constParams = {
          account_id: this.dboxMetaData.account_id,
          country_id: this.dboxMetaData.country_id,
          period: this.dboxMetaData.period,
          transaction_type: value.value,
          product_id: this.storeConfig.primaryKeyValue,
        };
        DBoxSalesService.filterSales({ ...constParams }).then((x) => {
          this.totalQty = x.data.total_qty;
        });
      }
      if (name == "usage_type") {
        this.usage_type = value.value;
      }
      this.dboxPluginStore.updateDBoxStoreMetaData((metaData) => {
        console.log({ metaData: metaData });
        return {
          ...metaData,
          [name]: value.value,
        };
      });
    },
    async onApplyFilter() {
      const constParams = {
        account_id: this.dboxMetaData.account_id,
        country_id: this.dboxMetaData.country_id,
        period: this.dboxMetaData.period,
      };

      const serviceParams = this.hasTransaction
        ? {
            transaction_type: this.dboxMetaData.transaction_type,
            product_id: this.storeConfig.primaryKeyValue,
            ...constParams,
          }
        : {
            track_id: this.storeConfig.primaryKeyValue,
            section: "tracks",
            action: "track_filter_tab_sales",
            usage_type: this.usage_type,
            ...constParams,
          };
      const salesRes = await DBoxSalesService.filterSales({ ...serviceParams });
      this.dboxPluginStore.updateDBoxStoreData((dboxData) => {
        return {
          ...dboxData,
          sales: salesRes.data.sales,
        };
      });
    },
    onStatementClick() {},
    onInvoiceClick(item) {
      routeWithFrom(this, {
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },
    resetFilter() {
      return {
        transaction_type: "",
        account_id: "",
        country_id: "",
        period: "",
      };
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
/**
86
,125
,125
,82
,71
,141
,55
,50
,75
,93
 */
.dtplugins-dbox-sales {
  &.no_items > .ut-fc {
    & > .ut-fc {
      overflow-y: hidden !important;
    }
    tbody.no_row {
      max-height: 28px !important;
    }
  }
  .search-controls {
    .dropdown {
      margin: 8px;
      --border-color: var(--bc-accent);
    }
  }
  .dt-ntable {
    tr {
      td {
        justify-content: flex-start;
        & > div,
        & > span {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>